import axios from "axios";
import React, { useState, useEffect } from "react";
import { XCircleIcon } from "@heroicons/react/20/solid";
import Link from "next/link";
import { ArrowLongLeftIcon } from "@heroicons/react/24/outline";
import { useRouter } from "next/navigation";

const SUCCESS_MESSAGE = "Reset link sent.";

function Login() {
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      const req = await axios.post(
        "https://backend.kobiworks.com/user/reset-password",
        {
          email: e.target.email.value,
        },
      );

      const responseMessage = req["data"]["message"];
      setMessage(responseMessage);
      setIsError(responseMessage !== SUCCESS_MESSAGE);
    } catch (err) {
      setMessage("Something went wrong. Please try again.");
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      return (window.location.href = "/dashboard");
    }
  }, []);

  return (
    <div className="w-full h-screen">
      <div className="flex min-h-full flex-1">
        <div
          onClick={() => router.back()}
          className="text-xs absolute top-4 left-4 flex justify-center items-center hover:text-blue-400 duration-300 cursor-pointer"
        >
          <ArrowLongLeftIcon className="h-5 w-5 mr-2" /> Go Back
        </div>
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                Reset your password
              </h2>
            </div>
            {message ? (
              <div
                className={`rounded-md p-4 mt-4 ${
                  isError ? "bg-red-50" : "bg-green-50"
                }`}
              >
                <div className="flex">
                  <div className="flex-shrink-0"></div>
                  <div className="ml-3">
                    <h3
                      className={`text-sm font-medium ${
                        isError ? "text-red-800" : "text-green-800"
                      }`}
                    >
                      {message}
                    </h3>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="mt-4">
              <div>
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Email address
                    </label>
                    <div className="mt-2">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        autoComplete="email"
                        className="px-2 block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>

                  <div className="flex items-center justify-between"></div>

                  {!loading ? (
                    <div>
                      <button
                        type="submit"
                        className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      >
                        Reset
                      </button>
                    </div>
                  ) : (
                    <div className="animate-pulse">
                      <button className="bg-gray-600 px-3 rounded-md w-full shadow-sm leading-6 py-1.5 text-sm font-semibold text-gray-900">
                        Loading...
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
            <Link href="/signup">
              <div className="w-full mt-4 text-sm cursor-pointer hover:underline duration-300">
                <h4>
                  New here?: <span className="text-blue-500">Sign up</span>
                </h4>
              </div>
            </Link>
            <Link href="/login">
              <div className="w-full mt-2 text-sm cursor-pointer hover:underline duration-300">
                <h4>
                  Login:
                  <span className="text-blue-500"> Login</span>
                </h4>
              </div>
            </Link>
          </div>
        </div>
        <div className="relative hidden w-0 flex-1 lg:block">
          <img
            alt=""
            src="https://i.imgur.com/y29QIMt.jpeg"
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}

export default Login;
